import { getField, updateField } from 'vuex-map-fields';

export default {
  name: 'userContext',
  namespaced: true,
  state: {
    isCustomer: '',
    isPrefilled: '',
    isRep: '',
    hasCustomerCredentials: false,
  },
  getters: {
    getField,
    userContext: (state) => state,
  },
  mutations: {
    updateField,
  },
};
